const ACCESS_KEY = import.meta.env.VITE_WEB3FORMS_ACCESS_KEY;
const ENDPOINT = 'https://api.web3forms.com/submit';

export async function submitToWeb3Forms({ source, fields }) {
  if (!ACCESS_KEY) {
    throw new Error('Falta VITE_WEB3FORMS_ACCESS_KEY en el entorno.');
  }

  const subject = `Random-College > nuevo lead desde el formulario de ${source}`;

  const payload = {
    access_key: ACCESS_KEY,
    subject,
    from_name: fields.nombre || fields.name || fields.email || 'Random-College',
    ...fields,
  };

  const res = await fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  });

  let data = {};
  try {
    data = await res.json();
  } catch {
    /* ignore */
  }

  if (!res.ok || !data.success) {
    throw new Error(data.message || `Submission failed (${res.status})`);
  }
  return data;
}
